import moment from 'moment'

class ReportLayoutService {
  /**
   * Get the first option as the default value if not specified on the definition.
   * @param {object} definition Layout definition object
   */
  getDefaultValue (definition) {
    if (definition && definition.defaultValue !== undefined) {
      return definition.defaultValue
    }
    if (definition && Array.isArray(definition.options)) {
      const filteredOptions = definition.options.filter(({ hide }) => (!hide))
      if (filteredOptions.length > 0) {
        return filteredOptions[0].value
      }
    }
  }

  /**
   * Get the minimum value from a given definition options.
   * @param {object} definition Layout definition object
   */
  getMinValue (definition) {
    const values = definition.options.map(({ value }) => definition.dateMode ? moment.utc(value).valueOf() : value)
    return Math.min(...values)
  }

  /**
   * Get the maximum value from a given definition options.
   * @param {object} definition Layout definition object
   */
  getMaxValue (definition) {
    const values = definition.options.map(({ value }) => definition.dateMode ? moment.utc(value).valueOf() : value)
    return Math.max(...values)
  }

  /**
   * Turn off slider labels for all but the first and last values
   * @param {object} definition Layout definition object
   */
  getSliderMarkerPoints (definition) {
    return definition.options.map((v, i) => {
      return {
        value: definition.dateMode ? moment.utc(v.value).toDate() : v.value,
        label: (i === 0 || i === definition.options.length - 1) ? v.label : undefined
      }
    })
  }

  /**
   * Perform a deep extend of property overrides
   *
   * @param {object} props
   * @param {object} overrides
   */
  applyPropOverrides (props, overrides) {
    const isPlainObject = (val) => (typeof val === 'object' && !(val instanceof Date) && !Array.isArray(val))

    // Return unmodified props if both are not plain objects
    if (!isPlainObject(props) || !isPlainObject(overrides)) {
      return props
    }

    const overrideKeys = Object.keys(overrides)
    if (overrideKeys.length > 0) {
      props = { ...props }
      overrideKeys.forEach((key) => {
        if (props[key] !== undefined && isPlainObject(props[key]) && isPlainObject(overrides[key])) {
          props[key] = this.applyPropOverrides(props[key], overrides[key])
        } else {
          props[key] = overrides[key]
        }
      })
    }

    return props
  }
}

export const reportLayoutService = new ReportLayoutService()
